import { bscTestnet } from 'viem/chains'


export const appChains = [ bscTestnet ] as const
